<template>
  <div class="appcompetences_footer">
    <router-link :to="ecranPrecedent" class="appcompetences_footer_precedent">&lt; Page précédente</router-link>
    <router-link v-if="ecranSuivant" :to="ecranSuivant" tag="button" class="appcompetences_footer_suivant button-app button-primary">{{ labelSuivant }}</router-link>
    <div class="hr-like"></div>
  </div>
</template>

<script>
export default {
  name: 'footer-applis',
  props: ['labelSuivant', 'ecranSuivant', 'ecranPrecedent'],
}
</script>

<style scoped>
.appcompetences_footer {
  border-top: solid 1px lightgrey;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
}

@media (min-width: 932px) {
  .appcompetences_footer {
    justify-content: space-between;
    flex-wrap: nowrap;
  }
}

.appcompetences_footer_precedent {
  float: left;
  margin: 0.5em;
  order: 1;
}

@media (min-width: 932px) {
  .appcompetences_footer_precedent {
    order: 0;
  }
}

.appcompetences_footer_suivant {
  float: right;
  margin: .5em;
  cursor: pointer;
  padding: 1rem 2.5rem;
  font-size: 1.2rem;
}

.hr-like {
  width: 100%;
}

@media (min-width: 932px) {
  .hr-like {
    display: none;
  }
}
</style>